import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    WarningItem,
    WarningList,
} from 'components/node_settings/V4EditSettingsModal/AdvancedSettingsTab/styled';

type AxisWarningsProps = Readonly<{
    messages: readonly string[];
    testId?: string;
}>;

export function AxisWarnings({ messages, testId }: AxisWarningsProps) {
    return (
        <WarningList data-testid={testId}>
            {messages.map((message) => (
                <WarningItem key={message}>
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                    {message}
                </WarningItem>
            ))}
        </WarningList>
    );
}
